export default __webpack_public_path__ + "static/media/video1.6f0682d9.mp4";